/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CommitImageRequest,
    CommitImageRequestFromJSON,
    CommitImageRequestToJSON,
} from '../models/CommitImageRequest';
import {
    type CommitImageResponse,
    CommitImageResponseFromJSON,
    CommitImageResponseToJSON,
} from '../models/CommitImageResponse';
import {
    type PresignUploadRequest,
    PresignUploadRequestFromJSON,
    PresignUploadRequestToJSON,
} from '../models/PresignUploadRequest';
import {
    type PresignUploadResponse,
    PresignUploadResponseFromJSON,
    PresignUploadResponseToJSON,
} from '../models/PresignUploadResponse';
import {
    type PresignViewResponse,
    PresignViewResponseFromJSON,
    PresignViewResponseToJSON,
} from '../models/PresignViewResponse';

export interface CommitRequest {
    /**
     * 
     */
    commitImageRequest: CommitImageRequest;
}

export interface PresignUploadOperationRequest {
    /**
     * 
     */
    presignUploadRequest: PresignUploadRequest;
}

export interface PresignViewRequest {
    /**
     * 
     */
    key: string;
}

/**
 * 
 */
export class ImageControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for commit without sending the request
     */
    async commitRequestOpts(requestParameters: CommitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['commitImageRequest'] == null) {
            throw new runtime.RequiredError(
                'commitImageRequest',
                'Required parameter "commitImageRequest" was null or undefined when calling commit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/images/commit`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommitImageRequestToJSON(requestParameters['commitImageRequest']),
        };
    }

    /**
     */
    async commitRaw(requestParameters: CommitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommitImageResponse>> {
        const requestOptions = await this.commitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommitImageResponseFromJSON(jsonValue));
    }

    /**
     */
    async commit(requestParameters: CommitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommitImageResponse> {
        const response = await this.commitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for presignUpload without sending the request
     */
    async presignUploadRequestOpts(requestParameters: PresignUploadOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['presignUploadRequest'] == null) {
            throw new runtime.RequiredError(
                'presignUploadRequest',
                'Required parameter "presignUploadRequest" was null or undefined when calling presignUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/images/presign-upload`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresignUploadRequestToJSON(requestParameters['presignUploadRequest']),
        };
    }

    /**
     */
    async presignUploadRaw(requestParameters: PresignUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresignUploadResponse>> {
        const requestOptions = await this.presignUploadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresignUploadResponseFromJSON(jsonValue));
    }

    /**
     */
    async presignUpload(requestParameters: PresignUploadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresignUploadResponse> {
        const response = await this.presignUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for presignView without sending the request
     */
    async presignViewRequestOpts(requestParameters: PresignViewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling presignView().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['key'] != null) {
            queryParameters['key'] = requestParameters['key'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/images/presign-view`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async presignViewRaw(requestParameters: PresignViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresignViewResponse>> {
        const requestOptions = await this.presignViewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresignViewResponseFromJSON(jsonValue));
    }

    /**
     */
    async presignView(requestParameters: PresignViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresignViewResponse> {
        const response = await this.presignViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
